import { type ProgramGuideItem } from "@ca.vmedia.tv/domains";
import { CardDataType, type ImageCardData, type PlayCardData, ComponentName } from "../types";

export class MixedCardData implements ImageCardData, PlayCardData {

    private readonly program: ProgramGuideItem;
    private readonly timeOnly: boolean;

    constructor(item: ProgramGuideItem, timeOnly: boolean = true) {
        this.program = item;
        this.timeOnly = timeOnly;
    }

    getId(): string {
        return `${this.program.id}`;
    }

    getImage(): string {
        return this.program.image ?? '';
    }

    getPlayItem(): ProgramGuideItem {
        return this.program;
    }

    getClass(): string {
        return 'mixed-card';
    }

    getType(): CardDataType {
        return CardDataType.Guide;
    }

    getComponentName(): ComponentName {
        return ComponentName.MIXED;
    }

    getProgram(): ProgramGuideItem {
        return this.program;
    }

    isTimeOnly(): boolean {
        return this.timeOnly;
    }

    getName(): string {
        if (this.isNotEmpty(this.program.seriesName)) {
            return this.program.seriesName!;
        }
        if (this.isNotEmpty(this.program.shortName)) {
            return this.program.shortName!;
        }
        if (this.isNotEmpty(this.program.name)) {
            return this.program.name!;
        }
        return "";
    }

    isNotEmpty(val: string | null): boolean {
        return (val != null && val.length > 0);
    }
    setPosition(pos: number): void {
        this.program.streamPosition = pos;
    }
}
